( function( $ ) {

    $(document).ready( function() {
        
  
        
        // A simpler alternative using grid layout
        function setEqualTabHeightsSimple($block) {
            const $tabPanes = $block.find('.st-content-tab__pane');
            let maxHeight = 0;
            
            // Temporarily clone and measure
            const $clone = $block.clone();
            
            // Remove any height restrictions
            $clone.find('.st-content-tab__pane').css({
                'display': 'block',
                'position': 'absolute',
                'visibility': 'hidden',
                'opacity': '0'
            });
            
            // Append to body temporarily
            $clone.css({
                'position': 'fixed',
                'left': '-9999px',
                'top': '0',
                'width': $block.outerWidth() + 'px'
            });
            
            $('body').append($clone);
            
            // Measure each pane
            $clone.find('.st-content-tab__pane').each(function() {
                const $pane = $(this);
                // Force display block for measurement
                $pane.css('display', 'block');
                
                const height = $pane.find('.st-content-tab__grid').outerHeight(true);
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });
            
            // Remove clone
            $clone.remove();
            
            // Apply height
            if (maxHeight > 0) {
                $tabPanes.find('.st-content-tab__grid').css('min-height', maxHeight + 'px');
            }
        }
        
        // Initialize tabs functionality
        function initContentTabs() {
            $('.st-content-tab-block').each(function() {
                const $block = $(this);
                const $tabButtons = $block.find('.st-content-tab__button');
                const $tabPanes = $block.find('.st-content-tab__pane');
                
                // Set first tab as active by default
                if (!$tabButtons.hasClass('active')) {
                    $tabButtons.first().addClass('active');
                    $tabPanes.first().addClass('active');
                }
                
                // Set equal heights after a short delay to ensure images are loaded
                setTimeout(() => {
                    setEqualTabHeightsSimple($block);
                }, 100);
                
                // Tab click handler
                $tabButtons.on('click', function(e) {
                    e.preventDefault();
                    
                    const $this = $(this);
                    const tabId = $this.data('tab');
                    
                    // Remove active classes
                    $tabButtons.removeClass('active');
                    $tabPanes.removeClass('active');
                    
                    // Add active classes to clicked tab
                    $this.addClass('active');
                    $block.find('#' + tabId).addClass('active');
                });
            });
        }
        
        // Initialize on page load
        initContentTabs();
        
        // Also initialize when all images are loaded
        $(window).on('load', function() {
            $('.st-content-tab-block').each(function() {
                setEqualTabHeightsSimple($(this));
            });
        });
        
        // Re-initialize when block is added in editor
        if (typeof wp !== 'undefined' && wp.data && wp.data.subscribe) {
            wp.data.subscribe(function() {
                setTimeout(initContentTabs, 300);
            });
        }
        
        // Recalculate heights on window resize (with debounce)
        let resizeTimer;
        $(window).on('resize', function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                $('.st-content-tab-block').each(function() {
                    setEqualTabHeightsSimple($(this));
                });
            }, 250);
        });
    } );

} )( jQuery );